// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3zGpq","selects":"Documents_selects__wrof4"};